import { Button, Icon, Text, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

export interface ProductSearchErrorProps {
  handleReload: () => void;
}

export const ProductSearchError: React.FC<ProductSearchErrorProps> = ({ handleReload }) => {
  return (
    <VStack alignItems="center" paddingY={Spacing['stack.xxxl']} height="100%">
      <VStack alignItems="center" space={Spacing['stack.nano']}>
        <Icon
          name="Warning"
          testId="error-icon"
          color={Color['feedback.attention.default']}
          size="md"
        />
        <Text fontSize={Typography['fontsize.lg']} variant="semibold" color="neutral.black">
          Ops, Algo deu errado!!
        </Text>
        <Text fontSize={Typography['fontsize.md']} color="neutral.black">
          No momento não conseguimos te mostrar os resultados.
        </Text>
        <Button
          justifyContent={'flex-start'}
          size={'lg'}
          variant="textLink"
          rightIcon={
            <Icon name="Refresh" size="xxs" testId="aa" color={Color['brand.tertiary.principal']} />
          }
          onPress={handleReload}>
          Recarregar
        </Button>
      </VStack>
    </VStack>
  );
};
